import { FormikValues, useFormikContext } from "formik";
import { get } from "lodash";
import { TimePicker, TimePickerProps } from "../components";

interface TimeFieldProps {
  name: string;
  label?: string;
}

/**
 * Formik-bound wrapper around `TimePicker` for `FormField type="time"`.
 * Value stays a plain "HH:mm" 24-hour string — identical to what the native
 * `<input type="time">` it replaces already produced.
 */
function TimeField<Value extends FormikValues>({
  name,
  ...props
}: TimeFieldProps & Omit<TimePickerProps, "onChange" | "value">) {
  const { setFieldValue, values } = useFormikContext<Value>();
  const value = get(values, name, "") as string;

  return (
    <TimePicker
      {...props}
      value={value}
      onChange={(newValue) => setFieldValue(name, newValue, true)}
    />
  );
}
export default TimeField;
